(function () {
  document.querySelectorAll('[data-gochi-copy-code]').forEach((button) => {
    button.addEventListener('click', () => {
      const code = button.dataset.gochiCopyCode;
      const copyLabel = button.querySelector('.gochi-preorder-banner__code-copy');
      const originalText = copyLabel ? copyLabel.textContent : null;

      navigator.clipboard.writeText(code).then(() => {
        button.setAttribute('data-copied', 'true');
        if (copyLabel) copyLabel.textContent = 'Copied!';
        setTimeout(() => {
          button.removeAttribute('data-copied');
          if (copyLabel && originalText) copyLabel.textContent = originalText;
        }, 1800);
      });
    });
  });
})();
